
@if (templateForPermitForm === true) {
<div class="janus-main-container">
  <!-- document container -->
  <a [href]="documentPath" target="blank" class="janus-document-name">
    <wm-common-text [data]="{text:documentName}"></wm-common-text>
  </a>
</div>
}@else {
<div class="row">
  <div class="col">
    <a [href]="documentPath" target="blank">{{ documentName }}</a>
  </div>
</div>
}